import { useQuery } from 'react-query';
import { ApiCollectionResponse } from 'types/api_response';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { Persona } from 'types/permissions_response';

export default function usePersonas<T extends Persona>(
  params = {},
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-resource-authorization/v1/resource-personas`;
  return useQuery<ApiCollectionResponse<T>, ServerErrorResponse>(
    ['personas', params],
    async ({ pageParam, signal }): Promise<ApiCollectionResponse<T>> => {
      try {
        const paramString = createParamString(params);
        const data: ApiCollectionResponse<T> = await fetcher({
          url: pageParam || `${url}?${paramString}`,
          options: { signal },
        });

        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: true,
      placeholderData: { content: [], count: 0, offset: 0 } as ApiCollectionResponse<T>,
      ...options,
    }
  );
}
